<template lang="pug">
  main(:class='$style.page')
    div(:class='$style.dashboard')
      slot(name='dashboard')
    div(:class='$style.search_widgets')
      slot(name='widgets')
    div(:class='$style.information')
      slot(name='information')
    div(:class='mainSlotClass')
      slot(name='main')
</template>

<script>
import EfilingMixin from '@/mixins/efiling'

export default {
  name: 'page-template',
  mixins: [EfilingMixin],
  props: {
    route: {
      type: String,
      default: null
    }
  },
  computed: {
    mainSlotClass () {
      return [
        this.$style.extra,
        { [this.$style.no_widgets]: !this.loggedIntoEfiling && this.route === 'isefs' }
      ]
    }
  }
}
</script>

<style lang="scss" module>
@import 'src/assets/styles/grid';

@media screen and (min-width: 1250px) {
  .page {
    @include display-grid();
    @include grid-template-columns(15rem 1fr 1fr);
    @include grid-template-rows(auto auto);
  }

  .dashboard {
    @include grid-column(1);
    @include grid-row(1, 2);
  }

  .information {
    @include grid-column(2);
    @include grid-row(1, 2);
  }

  .search_widgets {
    @include grid-column(3);
    @include grid-row(1);
  }

  .extra {
    @include grid-column(3);
    @include grid-row(2);

    &.no_widgets {
      @include grid-row(1)
    }
  }

  .dashboard,
  .information,
  .search_widgets,
  .extra {
    margin: 0 0.3rem 0.3rem 0.3rem;
  }
}

@media screen and (min-width: 800px) and (max-width: 1249px) {
  .page {
    @include display-grid();
    @include grid-template-columns(15rem 1fr);
    @include grid-template-rows(auto auto auto);
  }

  .dashboard {
    @include grid-column(1);
    @include grid-row(1, 3);
  }

  .information {
    @include grid-column(2);
    @include grid-row(2);
  }

  .search_widgets {
    @include grid-column(2);
    @include grid-row(1);
  }

  .extra {
    @include grid-column(2);
    @include grid-row(3);
  }

  .dashboard,
  .information,
  .search_widgets,
  .extra {
    margin: 0 0.3rem 0.3rem 0.3rem;
  }

}

@media screen and (max-width: 799px) {
  .page {
    @include display-grid();
    @include grid-template-columns(100%);
    @include grid-template-rows(auto auto auto auto);
  }

  .dashboard {
    @include grid-column(1);
    @include grid-row(1);
  }

  .information {
    @include grid-column(1);
    @include grid-row(3);
  }

  .search_widgets {
    @include grid-column(1);
    @include grid-row(2);
  }

  .extra {
    @include grid-column(1);
    @include grid-row(4);
  }

  .dashboard,
  .information,
  .search_widgets,
  .extra {
    margin: 0 0.3rem 0.3rem 0.3rem;
  }

}

@media print {
  .page,
  .dashboard,
  .information,
  .search_widgets,
  .extra {
    display: block !important;
  }
}

</style>
